import * as React from 'react';

import { cn } from '../lib/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
    ({ className, ...props }, ref) => {
        return (
            <textarea
                className={cn(
                    'flex min-h-[60px] w-full rounded-md border border-input bg-input-background dark:bg-input/30 px-3 py-2 text-base shadow-none placeholder:text-muted-foreground transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50',
                    'focus-visible:border-ring focus-visible:shadow-[0_0_0_2px_var(--color-accent)]',
                    'aria-invalid:border-destructive aria-invalid:shadow-[0_0_0_2px_color-mix(in_oklab,var(--color-destructive)_20%,transparent)] dark:aria-invalid:shadow-[0_0_0_2px_color-mix(in_oklab,var(--color-destructive)_40%,transparent)]',
                    className,
                )}
                ref={ref}
                {...props}
            />
        );
    },
);
Textarea.displayName = 'Textarea';

export { Textarea };
